// 差旅报销管理页面路由
const ClbxApply = () => import('@/views/cwgl/clbx/clbxApply.vue');
const ClbxApprove = () => import('@/views/cwgl/clbx/flow/flow_clbxApprove.vue');
const ClbxFlowApply = () => import('@/views/cwgl/clbx/flow/flow_clbxApply.vue');
const ClbxFlowHandle = () => import('@/views/cwgl/clbx/flow/flow_clbxHandle.vue');
const ClbxFlowCahier = () => import('@/views/cwgl/clbx/flow/flow_clbxCashier.vue');
const ClbxGl = () => import('@/views/cwgl/clbxgl/clbxgl.vue');
const ClbxFlowFinalHandle = () => import('@/views/cwgl/clbx/flow/flow_clbxFinalHandle.vue');
const ClbxBl = () => import('@/views/cwgl/clbxbl/index.vue');

export default [
  {
    path: '/cwgl/clbx/apply/',
    name: 'clbxApply',
    meta: {
      title: '差旅报销申请',
      path: ['财务管理', '差旅报销申请'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: ClbxApply
  },
  {
    path: '/cwgl/clbx/approve',
    name: 'clbxApprove',
    meta: {
      title: '差旅报销审批',
      path: ['财务管理', '差旅报销审批'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: ClbxApprove
  },
  {
    path: '/cwgl/clbx/flow/apply',
    name: 'clbxFlowApply',
    meta: {
      title: '差旅报销工作流申请',
      path: ['财务管理', '差旅报销工作流申请'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: ClbxFlowApply
  },
  {
    path: '/cwgl/clbx/flow/handle',
    name: 'clbxFlowHandle',
    meta: {
      title: '差旅报销处理',
      path: ['财务管理', '差旅报销处理'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: ClbxFlowHandle
  },
  {
    path: '/cwgl/clbx/flow/cahier',
    name: 'clbxFlowCahier',
    meta: {
      title: '差旅报销出纳',
      path: ['财务管理', '差旅报销出纳'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: ClbxFlowCahier
  },
  {
    path: '/cwgl/clbx/gl',
    name: 'clbxGl',
    meta: {
      title: '差旅报销管理',
      path: ['财务管理', '差旅报销管理'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: ClbxGl
  },
  {
    path: '/cwgl/clbx/flow/finalHandle',
    name: 'clbxFlowFinalHandle',
    meta: {
      title: '差旅报销最终处理',
      path: ['财务管理', '差旅报销最终处理'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: ClbxFlowFinalHandle
  },
  {
    path: '/cwgl/clbx/bl',
    name: 'clbxBl',
    meta: {
      title: '差旅报销补录',
      path: ['财务管理', '差旅报销补录'],
      icon: 'money',
      noCache: false,
      affix: true
    },
    component: ClbxBl
  }
];
